module.exports = __webpack_public_path__ + "static/img/2_2.34b2a80b.png";